export default "__VITE_ASSET__27e84ce0__"